import { makeAutoObservable } from "mobx";
import { consentFormToConsentData } from "helpers/forms/consent";
import type { ConsentFormValues } from "helpers/forms/consentTypes";
import { ConsentClient } from "./consentClient";
import { ConsentData, ConsentType } from "./consentTypes";

export class ConsentStore {
  private _consents: ConsentType[] = [];

  constructor(private readonly _consentClient: ConsentClient) {
    makeAutoObservable(this);
  }

  get consentsData(): ConsentType[] {
    return this._consents;
  }

  private set consentsData(consents: ConsentType[]) {
    this._consents = consents;
  }

  get hasAuConsents(): boolean {
    return (
      this._consents.includes(ConsentType.AuComplianceStatement) &&
      this._consents.includes(ConsentType.AnnaTerms) &&
      this._consents.includes(ConsentType.PrivacyPolicy)
    );
  }

  async init(): Promise<void> {
    this.consentsData = await this._consentClient.getConsents();
  }

  async updateConsents(values: ConsentFormValues): Promise<void> {
    this.consentsData = await this._consentClient.acceptConsents(consentFormToConsentData(values));
  }

  async acceptAcspIdentityVerificationConsent(): Promise<void> {
    this.consentsData = await this._consentClient.acceptConsents(
      new ConsentData({ items: [ConsentType.AcspIdentityVerification] }),
    );
  }
}
